import React, { useEffect } from "react";
import SVCards from "../components/SVCards";
import { calculateSeason } from "../components/Metadata/Utils.js";
import SVInfoSub from "../components/Usuarios/SVInfoSub";
import { useFilterContext } from "../components/Contexts/FilterProvider";

function SVTallerPage({ usuario }) {
  const { filter, setFilter } = useFilterContext();
  useEffect(() => {
    if (!filter) {
      setFilter({
        type: ["X"],
        season: calculateSeason(),
        title: "",
      });
    }
  }, [filter, setFilter]);

  return (
    <>
      {usuario.isSubscriptionActive && filter ? (
        <SVCards
          title="Taller de Teatre"
          filter={filter}
          saveFilter={setFilter}
        ></SVCards>
      ) : (
        <SVInfoSub />
      )}
    </>
  );
}

export default SVTallerPage;
